import { useRoutes } from 'react-router-dom'

import routes from './Routes'
import ReactGA from 'react-ga'
import React from 'react'

function App() {
  ReactGA.initialize('G-SFE893S7VV')
  ReactGA.pageview(window.location.pathname + window.location.search)
  const element = useRoutes(routes)

  return (
    <div>
      <React.Suspense fallback={<>...</>}>{element}</React.Suspense>
    </div>
  )
}
export default App
